import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<Link className="custom-cell__id" to={row.link}>
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</Link>
		);
	}

	if (field === 'req_id') {
		return (
			<Link className="custom-cell__link" to={row.req_link}>
				{row[field]}
			</Link>
		);
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
